import { Box, CircularProgress, Fade, Typography } from "@material-ui/core"
import * as React from "react"

class FullscreenLoading extends React.PureComponent {
    render() {
        return (
            <div
                style={{
                    position: "absolute",
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                    backgroundColor: "white",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}>
                <Fade in={true}>
                    <Box display="flex" flexDirection="column">
                        <CircularProgress disableShrink={true} style={{ margin: "0 auto" }} />
                        <Typography
                            color="textSecondary"
                            style={{ marginTop: "12px", paddingLeft: "4px", fontSize: "0.85rem" }}>
                            Loading...
                            {/*<Trans name="Loading..." />*/}
                        </Typography>
                    </Box>
                </Fade>
            </div>
        )
    }
}

export default FullscreenLoading
